import { TreatmentTypes } from './treatmentConsts'

export const ScanTrackingStatus = {
  Pending: 'pending',
  Submitted: 'submitted',
  NotRequired: 'not-required'
}

export const TreatmentTrackOptions = {
  OnTrack: 'on-track',
  OffTrack: 'not-on-track'
}

export const TrackingSelectionModes = {
  None: 'none',
  Teeth: 'teeth',
  Arches: 'arches'
}

export const TrackingConditionsTypes = {
  AlignersFit: 'aligners-fit',
  AlignerUnseating: 'aligner-unseating',
  AlignerSlightlyUnseating: 'aligner-slightly-unseating',
  AlignerSignificantlyUnseating: 'aligner-significantly-unseating',
  LastAligner: 'last-aligner',
  MissingAttachments: 'missing-attachments',
  PassiveWire: 'passive-wire',
  WireOutOfBracket: 'wire-out-of-bracket',
  BrokenWire: 'broken-wire',
  MissingOTie: 'missing-o-tie',
  MissingBracket: 'missing-bracket',
  BrokenChain: 'broken-chain',
  CritiallyBadHygiene: 'critical-hygiene',
  BadHygiene: 'bad-hygiene',
  InvalidScan: 'invalid-scan',
  TxGoalReached: 'tx-goal-reached',
  RPELowCompliance: 'rpe-low-compliance',
  ElasticLowCompliance: 'elastic-low-compliance',
  IPRReady: 'ipr-ready',
  Other: 'other'
}

export const OldTrackingConditionsTypes = {
  AlignersFit: 'aligners-fit',
  MissingAttachments: 'missing-attachments',
  PassiveWire: 'passive-wire',
  WireOutOfBracket: 'wire-out-of-bracket',
  BrokenWire: 'broken-wire',
  MissingOTie: 'missing-o-tie',
  MissingBracket: 'missing-bracket',
  BrokenChain: 'broken-chain',
  CritiallyBadHygiene: 'critical-hygiene',
  BadHygiene: 'bad-hygiene',
  InvalidScan: 'invalid-scan',
  Other: 'other'
}

export const TrackingConditions = {
  [TrackingConditionsTypes.AlignerUnseating]: {
    id: TrackingConditionsTypes.AlignerUnseating,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.AlignersFit]: {
    id: TrackingConditionsTypes.AlignersFit,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.AlignerSlightlyUnseating]: {
    id: TrackingConditionsTypes.AlignerSlightlyUnseating,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.AlignerSignificantlyUnseating]: {
    id: TrackingConditionsTypes.AlignerSignificantlyUnseating,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.MissingAttachments]: {
    id: TrackingConditionsTypes.MissingAttachments,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.PassiveWire]: {
    id: TrackingConditionsTypes.PassiveWire,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.WireOutOfBracket]: {
    id: TrackingConditionsTypes.WireOutOfBracket,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.BrokenWire]: {
    id: TrackingConditionsTypes.BrokenWire,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.MissingOTie]: {
    id: TrackingConditionsTypes.MissingOTie,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.MissingBracket]: {
    id: TrackingConditionsTypes.MissingBracket,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.BrokenChain]: {
    id: TrackingConditionsTypes.BrokenChain,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.TxGoalReached]: {
    id: TrackingConditionsTypes.TxGoalReached,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.RPELowCompliance]: {
    id: TrackingConditionsTypes.RPELowCompliance,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.ElasticLowCompliance]: {
    id: TrackingConditionsTypes.ElasticLowCompliance,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.IPRReady]: {
    id: TrackingConditionsTypes.IPRReady,
    selectionMode: TrackingSelectionModes.None,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.BadHygiene]: {
    id: TrackingConditionsTypes.BadHygiene,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OnTrack, TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.BadHygiene]: {
    id: TrackingConditionsTypes.BadHygiene,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OnTrack, TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.CritiallyBadHygiene]: {
    id: TrackingConditionsTypes.CritiallyBadHygiene,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.Other]: {
    id: TrackingConditionsTypes.Other,
    selectionMode: TrackingSelectionModes.None,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack],
    withNote: true
  }
}

export const OldTrackingConditions = {
  [TrackingConditionsTypes.AlignersFit]: {
    id: TrackingConditionsTypes.AlignersFit,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.MissingAttachments]: {
    id: TrackingConditionsTypes.MissingAttachments,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Aligners],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.PassiveWire]: {
    id: TrackingConditionsTypes.PassiveWire,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.WireOutOfBracket]: {
    id: TrackingConditionsTypes.WireOutOfBracket,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.BrokenWire]: {
    id: TrackingConditionsTypes.BrokenWire,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.MissingOTie]: {
    id: TrackingConditionsTypes.MissingOTie,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.MissingBracket]: {
    id: TrackingConditionsTypes.MissingBracket,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.BrokenChain]: {
    id: TrackingConditionsTypes.BrokenChain,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: [TreatmentTypes.Braces],
    trackingStatus: [TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.BadHygiene]: {
    id: TrackingConditionsTypes.BadHygiene,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OnTrack, TreatmentTrackOptions.OffTrack]
  },
  [TrackingConditionsTypes.CritiallyBadHygiene]: {
    id: TrackingConditionsTypes.CritiallyBadHygiene,
    selectionMode: TrackingSelectionModes.Teeth,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack]
  },
  [TrackingConditionsTypes.Other]: {
    id: TrackingConditionsTypes.Other,
    selectionMode: TrackingSelectionModes.None,
    treatmentTypes: Object.values(TreatmentTypes),
    trackingStatus: [TreatmentTrackOptions.OffTrack, TreatmentTrackOptions.OnTrack],
    withNote: true
  }
}

export const GI_RESULT_MSG_TYPE = 'gi-result'

export const NotifyPracticeReasons = {
  Clinical: 'clinical',
  Scheduling: 'scheduling',
  MissingInfo: 'missingInfo',
  PatientQuestion: 'patientQuestion',
  SpecificMembersAttention: 'specificMembersAttention',
  // Set by practice automations, never chosen by a person — see humanSelectableNotifyPracticeReasons.
  Automation: 'automation',
  Other: 'other'
}

// Order the reason chips appear in on the Copilot Needs Attention widget. The container wraps
// naturally, so adding a reason reflows instead of needing rows rebalanced by hand.
export const NEEDS_ATTENTION_REASON_ORDER = [
  NotifyPracticeReasons.Clinical,
  NotifyPracticeReasons.Scheduling,
  NotifyPracticeReasons.MissingInfo,
  NotifyPracticeReasons.SpecificMembersAttention,
  NotifyPracticeReasons.PatientQuestion,
  NotifyPracticeReasons.Automation,
  NotifyPracticeReasons.Other
]

// Order the reason checkboxes appear in under "My attention is required" in Notification
// Settings. Kept separate from the chip order only to preserve the existing layout; both must
// cover every reason, which notifyPracticeReasons.test.js enforces.
export const NEEDS_ATTENTION_FILTER_OPTIONS = [
  NotifyPracticeReasons.Clinical,
  NotifyPracticeReasons.MissingInfo,
  NotifyPracticeReasons.PatientQuestion,
  NotifyPracticeReasons.Scheduling,
  NotifyPracticeReasons.SpecificMembersAttention,
  NotifyPracticeReasons.Automation,
  NotifyPracticeReasons.Other
]

// The reasons a person may pick in the Notify Practice dialog. Automation is excluded: it marks
// a flag as machine-raised, so letting someone select it would defeat the distinction and
// pollute the needsAttentionReason aggregation Copilot groups on.
export const humanSelectableNotifyPracticeReasons = Object.fromEntries(
  Object.entries(NotifyPracticeReasons).filter(([, reason]) => reason !== NotifyPracticeReasons.Automation)
)
